import request from '@/utils/request'

// ===============仓储入库================


//仓储入库新增（暂时保存）
export function rukuAddTemp(data) {
  return request({
    method: 'post',
    url: "/yzdservice/api/storage/rkTemp",
    data: JSON.parse(JSON.stringify(data))
  })
}

//仓储入库新增（入库）
export function rukuAdd(data) {
    return request({
        method: 'post',
        url: "/yzdservice/api/storage/rk",
        data: JSON.parse(JSON.stringify(data))
    })
}

//仓储入库查询
export function rukuPage(data) {
    return request({
        method: 'post',
        url: "/yzdservice/api/storage/rk/page",
        data: data
    })
}

//仓储入库删除
export function rukuDraft(id) {
    return request({
        method: 'delete',
        url: "/yzdservice/api/storage/rk/draft/" + id
    })
}

//仓储入库草稿编辑
export function CGEditTemp(data) {
  return request({
    method: 'put',
    url: "/yzdservice/api/storage/rk/draftTemp",
    data: data
  })
}

//仓储入库草稿编辑
export function CGEdit(data) {
    return request({
        method: 'put',
        url: "/yzdservice/api/storage/rk/draft",
        data: data
    })
}
//获取化学品信息
export function getHxpCascader() {
    return request({
        method: 'get',
        url: "/yzdservice/api/enterprise/credentials/common/getHxpCascader"
    })
}

// 获取级联下 单位
export function gethqdw(bm) {
    return request({
        method: 'get',
        url: "/yzdservice/common/hxpDw/" + bm
    })
}



//获取经办人信息
export function getgetLyrList() {
    return request({
        method: 'get',
        url: "/yzdservice/enterprise/dwCk/syck/getLyrList"
    })
}

//选择仓库信息
export function getCkxxByCskc(ckId) {
  if(ckId){
    return request({
      method: 'get',
      url: "/yzdservice/enterprise/dwCk/getCkxxByCskc/"+ckId
    })
  }else{
    return request({
      method: 'get',
      url: "/yzdservice/enterprise/dwCk/getCkxxByCskc"
    })
  }
}

//获取委托单位
export function getWTDW() {
    return request({
        method: 'get',
        url: "/yzdservice/enterprise/wldw/rkList"
    })
}
//获取状态
export function getZT() {
    return request({
        method: 'get',
        url: "/yzdservice/api/enum/rk/ty"
    })
}

//变更之前
export function getBGMessage(data) {
    return request({
        method: 'put',
        url: "/yzdservice/api/storage/rk/message",
        data: data
    })

}
//变更
export function ccrkBG(data) {
    return request({
        method: 'put',
        url: "/yzdservice/api/storage/rk",
        data: data
    })

}

export function userInfo() {
    return request({
        method: 'get',
        url: "/organization/api/user/userInfo"
    })

}

//导出
export function excelwriter(data) {
    return request({
        method: 'post',
        url: "/yzdservice/api/storage/rk/export",
        data: data,
        responseType: 'blob'
    })
}

// ===============仓储入库end================

//==================================仓储出库

//出入库获取运输证列表
export function getCkxxList(data) {
    return request({
        method: 'post',
        url: "/yzdservice/api/storage/ck/page",
        data: data
    })
}
//选择仓库信息
export function getSelectCkxx() {
    return request({
        method: 'get',
        url: "/yzdservice/enterprise/dwCk/getCkxxByCskc"
    })
}
//委托单位下拉
export function getWtdw() {
    return request({
        method: 'get',
        url: "/yzdservice/api/storage/wtDw/list"
    })
}
//分页时查看状态
export function getStatus() {
    return request({
        method: 'get',
        url: "/yzdservice/api/enum/ck/ty"
    })
}
//出库新增（暂时保存）
export function addCkTemp(data) {
    return request({
        method: 'post',
        url: "/yzdservice/api/storage/ckTemp",
        data: data
    })
}
//出库新增（出库保存）
export function addCk(data) {
    return request({
        method: 'post',
        url: "/yzdservice/api/storage/ck",
        data: data
    })
}
//出库编辑（暂时保存）
export function editDraftTemp(data) {
    return request({
        method: 'put',
        url: "/yzdservice/api/storage/ck/draftTemp",
        data: data
    })
}
//出库编辑（出库保存）
export function editDraft(data) {
    return request({
        method: 'put',
        url: "/yzdservice/api/storage/ck/draft",
        data: data
    })
}
//出库草稿删除
export function deleteDreft(id) {
    return request({
        method: 'delete',
        url: "/yzdservice/api/storage/ck/draft/" + id
    })
}
//导出 参数跟分页一致
export function exportData(data) {
    return request({
        method: 'post',
        url: "/yzdservice/api/storage/ck/export",
        responseType: 'blob',
        data: data
    })
}
//下拉获取化学品  出库 报备时新增编辑使用
export function getHxpData(id) {
    return request({
        method: 'get',
        url: "/yzdservice/api/storage/hxp/list/" + id
    })
}
//下拉获取仓库  出库 报备时新增编辑使用
export function ckxxAndKcxx(wtdmId, hxpBm) {
    return request({
        method: 'get',
        url: "/yzdservice/api/storage/ckxxAndKcxx/" + wtdmId + "/" + hxpBm
    })
}
//--put 变更出库校验
export function getCkChangeMsg(data) {
    return request({
        method: 'put',
        url: "/yzdservice/api/storage/ck/message",
        data: data
    })
}
// --put 变更出库
export function getCkChange(data) {
    return request({
        method: 'put',
        url: "/yzdservice/api/storage/ck",
        data: data
    })
}
